import React from "react"

export const LoggedIn: React.FC = () => {
    return (
        <div>loggedin!</div>
    )
}
